const Stats = () => {
  const stats = [
    { number: '5,000+', label: 'Certified Coaches' },
    { number: '30+', label: 'Countries' },
    { number: '200+', label: 'Accredited Programs' },
    { number: '20', label: 'Domains Classified' },
  ];

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Stats;